<template>
    <div class="vue-video">
        <template v-if="hasVideo">
            <video playsinline autoplay loop muted>
                <source :src="computedVideoSource.url" :type="computedVideoSource.mime">
            </video>
        </template>
    </div>
</template>

<script>
export default {
    name: "Video",

    props: {
        video: {
            type: Object,
            required: true,
        },
        mobileVideo: {
            type: Object,
        },
        hasVideo: {
            type: Boolean,
            default: false
        },
        isMobile: {
            type: Boolean,
        }
    },

    computed: {
        computedVideoSource() {
            if (this.isMobile && !_.isEmpty(this.mobileVideo)) {
                return this.mobileVideo
            }

            return this.video
        }
    }
}
</script>